module.exports = __webpack_public_path__ + "img/example.245399d.png";